export default class AddToCartParameterHolder {

    itemId: string = '';
    userId: string = '';

    AddToCartParameterHolder() {
        this.itemId = '';
        this.userId = '';
    }

    toMap(): {} {
        const map = {};
        map['item_id'] = this.itemId;
        map['user_id'] = this.userId;

        return map;
    }
}